import React from 'react'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'

const Wrapper = styled.div``

export default injectIntl((props) => {

    const { heading = 'No.Markers'} = props;

    return (
        <Wrapper>
            {props.intl.formatMessage({id:heading})}
        </Wrapper>
    )
})